import * as React from "react";
import { Form, Checkbox } from "semantic-ui-react";

export type CheckboxFieldProps = {
  id: string;
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  disabled?: boolean;
};

function CheckboxField({
  id,
  label,
  checked,
  onChange,
  disabled
}: CheckboxFieldProps): JSX.Element {
  return (
    <Form.Field className="edit-checkbox-property">
      <Checkbox
        label={<label id={id}>{label}</label>}
        checked={checked}
        onChange={() => {
          onChange(!checked);
        }}
        disabled={disabled}
      />
    </Form.Field>
  );
}

export default CheckboxField;
